import { student_for_batchQuery } from '@app-types/graphql-types';
import { TransferItem } from 'antd/es/transfer';

export const getStudentsForManageBatchStudentsTransfer = (
  selectedBatch: string,
  selectedBatchClass: string,
  students?: student_for_batchQuery['student_for_batch'],
): TransferItem[] => {
  if (students) {
    const studentsForSelect = students.map((student) => {
      return {
        key: student.id ? student.id.toString() : '',
        title: `${student.sliitID} - ${student.firstName} ${student.lastName}`,
        gender: student.gender,
        batchClassIds: student.student_batch_classes_batch_classes.map((batchClass) => batchClass.batchClassId),
        disabled: Boolean(
          student.student_batch_classes_batch_classes.find(
            (studentBatchClass) =>
              studentBatchClass?.batch_class?.batchId === selectedBatch &&
              studentBatchClass?.batch_class?.id !== selectedBatchClass,
          ),
        ),
      };
    });

    return studentsForSelect.sort((firstValue, secondValue) => firstValue.title.localeCompare(secondValue.title));
  }

  return [];
};
